import React from "react";

import { toast } from "react-toastify";
import AllVendors from "./AllVendors";

class AddVendor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      vendorName: "",
      factoryAddress: "",
      nextPoNumber: "",
      poPrefix: "",
      shippingTerms: "",
      paymentTerms: "",
      shippingMethod: "",
      validationErrors: {},
    };

    this.createVendor = this.createVendor.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (e) => {
    const { name, value } = e.target;

    this.setState({ [e.target.name]: e.target.value });

    this.setState({
      [name]: value,
      validationErrors: {
        ...this.state.validationErrors,
        [name]: "", // Clear validation error when input changes
      },
    });
  };

  validateInputs = () => {
    const {
      vendorName,
      factoryAddress,
      nextPoNumber,
      poPrefix,
      shippingTerms,
      paymentTerms,
      shippingMethod,
    } = this.state;

    let errors = {};

    if (!vendorName.trim()) {
      errors.vendorName = "Vendor name is required !!";
    }

    if (!factoryAddress.trim()) {
      errors.factoryAddress = "Factory address is required !!";
    }
    if (!nextPoNumber.trim()) {
      errors.nextPoNumber = "Next PoNumber is required !!";
    }

    if (!poPrefix.trim()) {
      errors.poPrefix = "PoPrefix is required !!";
    }
    if (!shippingTerms.trim()) {
      errors.shippingTerms = "Shipping Terms is required !!";
    }

    if (!paymentTerms.trim()) {
      errors.paymentTerms = "Payment Terms is required !!";
    }

    if (!shippingMethod.trim()) {
      errors.shippingMethod = "Shipping Method is required !!";
    }

    return errors;
  };

  // create vendors

  createVendor = async (e) => {
    e.preventDefault();

    const validationErrors = this.validateInputs();

    console.log("error", validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      this.setState({ validationErrors });
      return;
    }
 
    var formdata = new FormData();
    formdata.append("vendorName", this.state.vendorName);
    formdata.append("factoryAddress", this.state.factoryAddress);
    formdata.append("nextPoNumber", this.state.nextPoNumber);
    formdata.append("poPrefix", this.state.poPrefix);
    formdata.append("shippingTerms", this.state.shippingTerms);
    formdata.append("paymentTerms", this.state.paymentTerms);
    formdata.append("shippingMethod", this.state.shippingMethod);

    var requestOptions = {
      method: "POST",
      body: formdata,
      // redirect: 'follow'
    };

    toast.success("Vendor Add successfully");
   await fetch(
      "https://dashboard.realsexdoll.info/php/vendors/createvendor.php",
      requestOptions
    )
      .then(
        (response) => response.text(),

        window.location.reload()

        //this.props.history.push("/vendorlist")
        
      )
      .catch((error) => console.log("error", error));
  };

  render() {
    const {
      vendorName,
      factoryAddress,
      nextPoNumber,
      poPrefix,
      shippingTerms,
      paymentTerms,
      shippingMethod,
      validationErrors,
    } = this.state;

    return (
      <>
        <div className="container">
          <div class="modal show fade d-block" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
              <form onSubmit={this.createVendor}>
                <div class="modal-content">
                  <div class="modal-header">
                    {/* onClick={() => this.props.handleClose()} */}
                    <h5 class="modal-title">Add Vendor</h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      onClick={() => this.props.handleClose()}
                    ></button>
                  </div>
                  <div class="modal-body">
                    <div className="row">
                      <div className="col-6">
                        <label
                          for="exampleFormControlInput1"
                          class="form-label"
                        >
                          Vendor Name
                        </label>
                        <input
                          type="text"
                          class="form-control mb-4"
                          id="exampleFormControlInput1"
                          onChange={this.handleChange}
                          name="vendorName"
                          value={vendorName}
                        />
                        <span style={{ color: "red" }} className="error">
                          {validationErrors.vendorName}
                        </span>
                      </div>

                      <div className="col-6">
                        <label
                          for="exampleFormControlInput1"
                          class="form-label"
                        >
                          Factory Address
                        </label>
                        <input
                          type="text"
                          class="form-control mb-4"
                          id="exampleFormControlInput1"
                          onChange={this.handleChange}
                          name="factoryAddress"
                          value={factoryAddress}
                        />
                        <span style={{ color: "red" }} className="error">
                          {validationErrors.factoryAddress}
                        </span>
                      </div>

                      <div className="col-6">
                        <label
                          for="exampleFormControlInput1"
                          class="form-label"
                        >
                          Next PONumber
                        </label>
                        <input
                          type="text"
                          class="form-control mb-4"
                          id="exampleFormControlInput1"
                          onChange={this.handleChange}
                          name="nextPoNumber"
                          value={nextPoNumber}
                        />
                        <span style={{ color: "red" }} className="error">
                          {validationErrors.nextPoNumber}
                        </span>
                      </div>

                      <div className="col-6">
                        <label
                          for="exampleFormControlInput1"
                          class="form-label"
                        >
                          Po Prefix
                        </label>
                        <input
                          type="text"
                          class="form-control mb-4"
                          id="exampleFormControlInput1"
                          onChange={this.handleChange}
                          name="poPrefix"
                          value={poPrefix}
                        />
                        <span style={{ color: "red" }} className="error">
                          {validationErrors.poPrefix}
                        </span>
                      </div>
                      <div className="col-6">
                        <label
                          for="exampleFormControlInput1"
                          class="form-label"
                        >
                          Shipping Terms
                        </label>
                        <input
                          type="text"
                          class="form-control mb-4"
                          id="exampleFormControlInput1"
                          onChange={this.handleChange}
                          name="shippingTerms"
                          value={shippingTerms}
                        />
                        <span style={{ color: "red" }} className="error">
                          {validationErrors.shippingTerms}
                        </span>
                      </div>

                      <div className="col-6">
                        <label
                          for="exampleFormControlInput1"
                          class="form-label"
                        >
                          Payment Terms
                        </label>
                        <input
                          type="text"
                          class="form-control mb-4"
                          id="exampleFormControlInput1"
                          onChange={this.handleChange}
                          name="paymentTerms"
                          value={paymentTerms}
                        />
                        <span style={{ color: "red" }} className="error">
                          {validationErrors.paymentTerms}
                        </span>
                      </div>

                      <div className="col-6">
                        <label
                          for="exampleFormControlInput1"
                          class="form-label"
                        >
                          Shipping Method
                        </label>
                        <input
                          type="text"
                          class="form-control mb-4"
                          id="exampleFormControlInput1"
                          onChange={this.handleChange}
                          name="shippingMethod"
                          value={shippingMethod}
                        />
                        <span style={{ color: "red" }} className="error">
                          {validationErrors.shippingMethod}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-danger"
                      data-bs-dismiss="modal"
                      onClick={() => this.props.handleClose()}
                    >
                      Close
                    </button>
                    <button
                      type="submit"
                      class="btn btn-primary"
                      
                    >
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default AddVendor;
